import React from 'react';
import { render } from 'react-dom';
import { Modal } from 'antd';

let container = null;
export default function (content, option = {}) {
    return new Promise(resolve => {
        function display(visible) {
            render(
                <Modal title={option.title || '确认'} visible={visible}
                    onOk={() => finish(true)} onCancel={() => finish(false)}
                    okText='确定' cancelText='取消'
                >
                    {content}
                </Modal>, container);
        }
        function finish(r) {
            display(false);
            resolve(r);
        }
        if (!container) {
            container = document.createElement('div');
        }
        display(true);
    });
}